// Concepts flagged as `is_custom` by the API are served from their own path
// segment (`/projects/:partnerId/custom-concept/:conceptId/:type`) so the
// custom concept views can be rendered instead of the standard ones.
export const CONCEPT_SEGMENT = 'concept';
export const CUSTOM_CONCEPT_SEGMENT = 'custom-concept';

export const conceptSegments = [CONCEPT_SEGMENT, CUSTOM_CONCEPT_SEGMENT];

export const getConceptSegment = (isCustom) =>
  isCustom ? CUSTOM_CONCEPT_SEGMENT : CONCEPT_SEGMENT;
